import WithRender from "../../templates/layouts/layoutUploadConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCimpressNoQuantity"])
  }
});
